import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import { FullWidthContent } from '../../JurisdictionView/EventPane/tabs/OverviewTab/OverviewTab.styles';
import AirAmbulanceStatus from '../AirAmbulanceStatus/AirAmbulanceStatus';
import AirAmbulancePageHeader from '../AirAumbulancePage/AirAmbulancePageHeader';
import AirAmbulanceEtlTest from './AirAmbulanceEtlTest';
import AirAmbulanceFormStandalone from './AirAmbulanceFormStandalone';
import { FORM_PAGES, FORM_HEADER, STATUS_HEADER } from './constants';
import { useTentativeETA } from './hooks';
import { useExistingRequest } from './hooks/useExistingRequest';

const AirAmbulanceForm = ({ fromMapCard = false }) => {
  const { formPageToShow } = useSelector(state => state.airAmbulance);
  const { selectedCallerID, callQueue } = useSelector(
    state => state.emergencyCalls,
  );
  const {
    existingRequest,
    existingRequestBody,
    latestVehicle,
    latestProvider,
  } = useExistingRequest();

  const hasLocationToRender = useMemo(
    () => getMostRecentLoc(callQueue[selectedCallerID]),
    [selectedCallerID, callQueue],
  );
  const tentativeETA = useTentativeETA();

  const { currentHeader, currentPage } = useMemo(() => {
    if (formPageToShow === FORM_PAGES.STATUS && existingRequest) {
      const brand_tail = existingRequestBody?.brand_tail;

      return {
        currentHeader: {
          ...STATUS_HEADER,
          subText: [latestVehicle?.name, brand_tail, latestProvider?.name]
            .filter(Boolean)
            .join(' - '),
        },
        currentPage: <AirAmbulanceStatus />,
      };
    }

    return {
      currentHeader: {
        ...FORM_HEADER,
        subText: tentativeETA?.display,
      },
      currentPage: (
        <AirAmbulanceFormStandalone
          hasLocationToRender={hasLocationToRender}
          tentativeETA={tentativeETA}
          fromMapCard={fromMapCard}
        />
      ),
    };
  }, [
    formPageToShow,
    hasLocationToRender,
    existingRequest,
    tentativeETA,
    existingRequestBody?.brand_tail,
    fromMapCard,
    latestProvider?.name,
    latestVehicle?.name,
  ]);

  return (
    <FullWidthContent backgroundColor="background">
      <AirAmbulancePageHeader
        text={currentHeader?.text}
        subtext={currentHeader?.subText}
        hideBackButton={!selectedCallerID}
      />
      {currentPage}
      <AirAmbulanceEtlTest />
    </FullWidthContent>
  );
};

export default AirAmbulanceForm;
